module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pure-u-1 sso-buttons"
  }, [_c('p', {
    staticClass: "sso-hint"
  }, [_vm._v("\n    Use Tavour in the app? Sign in the same way here, so your club joins your existing account.\n  ")]), _vm._v(" "), (_vm.error) ? _c('div', {
    staticClass: "text-red sso-error",
    attrs: {
      "role": "alert"
    }
  }, [_vm._v("\n    " + _vm._s(_vm.error.text) + "\n    "), (_vm.error.link) ? _c('a', {
    staticClass: "link",
    attrs: {
      "href": _vm.error.link.href,
      "target": "_blank",
      "rel": "noopener"
    }
  }, [_vm._v(_vm._s(_vm.error.link.label))]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.googleBlocked) ? _c('p', {
    staticClass: "sso-notice"
  }, [_vm._v("\n    To sign in with Google, open this page in Safari or Chrome.\n  ")]) : _c('button', {
    staticClass: "pure-button sso-button",
    attrs: {
      "type": "button",
      "disabled": _vm.busy !== null,
      "aria-busy": _vm.busy === _vm.providers.google
    },
    on: {
      "click": function($event) {
        return _vm.signIn(_vm.providers.google)
      }
    }
  }, [_c('svg', {
    staticClass: "sso-logo",
    attrs: {
      "viewBox": "0 0 18 18",
      "aria-hidden": "true"
    }
  }, [_c('path', {
    attrs: {
      "fill": "#EA4335",
      "d": "M9 3.48c1.69 0 2.83.73 3.48 1.34l2.54-2.48C13.46.89 11.43 0 9 0 5.48 0 2.44 2.02.96 4.96l2.91 2.26C4.6 5.05 6.62 3.48 9 3.48z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "fill": "#4285F4",
      "d": "M17.64 9.2c0-.74-.06-1.28-.19-1.84H9v3.34h4.96c-.1.83-.64 2.08-1.84 2.92l2.84 2.2c1.7-1.57 2.68-3.88 2.68-6.62z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "fill": "#FBBC05",
      "d": "M3.88 10.78A5.54 5.54 0 0 1 3.58 9c0-.62.11-1.22.29-1.78L.96 4.96A9.008 9.008 0 0 0 0 9c0 1.45.35 2.82.96 4.04l2.92-2.26z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "fill": "#34A853",
      "d": "M9 18c2.43 0 4.47-.8 5.96-2.18l-2.84-2.2c-.76.53-1.78.9-3.12.9-2.38 0-4.4-1.57-5.12-3.74L.97 13.04C2.45 15.98 5.48 18 9 18z"
    }
  })]), _vm._v("\n    " + _vm._s(_vm.busy === _vm.providers.google ? 'Opening Google...' : 'Continue with Google') + "\n  ")]), _vm._v(" "), _c('button', {
    staticClass: "pure-button sso-button",
    attrs: {
      "type": "button",
      "disabled": _vm.busy !== null,
      "aria-busy": _vm.busy === _vm.providers.apple
    },
    on: {
      "click": function($event) {
        return _vm.signIn(_vm.providers.apple)
      }
    }
  }, [_c('svg', {
    staticClass: "sso-logo",
    attrs: {
      "viewBox": "0 0 814 1000",
      "aria-hidden": "true"
    }
  }, [_c('path', {
    attrs: {
      "fill": "#000",
      "d": "M788.1 340.9c-5.8 4.5-108.2 62.2-108.2 190.5 0 148.4 130.3 200.9 134.2 202.2-.6 3.2-20.7 71.9-68.7 141.9-42.8 61.6-87.5 123.1-155.5 123.1s-85.5-39.5-164-39.5c-76.5 0-103.7 40.8-165.9 40.8s-105.6-57-155.5-127C46.7 790.7 0 663 0 541.8c0-194.4 126.4-297.5 250.8-297.5 66.1 0 121.2 43.4 162.7 43.4 39.5 0 101.1-46 176.3-46 28.5 0 130.9 2.6 198.3 99.2zm-234-181.5c31.1-36.9 53.1-88.1 53.1-139.3 0-7.1-.6-14.3-1.9-20.1-50.6 1.9-110.8 33.7-147.1 75.8-28.5 32.4-55.1 83.6-55.1 135.5 0 7.8 1.3 15.6 1.9 18.1 3.2.6 8.4 1.3 13.6 1.3 45.4 0 102.5-30.4 135.5-71.3z"
    }
  })]), _vm._v("\n    " + _vm._s(_vm.busy === _vm.providers.apple ? 'Opening Apple...' : 'Continue with Apple') + "\n  ")]), _vm._v(" "), _vm._m(0)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "sso-divider"
  }, [_c('span', [_vm._v("or use your email")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-aa49c682!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/account/SsoButtons.vue
// module id = 410
// module chunks = 1